import { 
  persist as apiPersist,
  recallChildren as apiRecallChildren,
  deleteQwanta as apiDeleteQwanta,
  recursiveDelete as apiRecursiveDelete,
  sync as apiSync,
  getBatch as apiGetBatch,
  getPreviousBatch as apiGetPreviousBatch,
  getTotalCount as apiGetTotalCount
} from "./api-client";

// For backward compatibility - now just throws error since we use API
export function qwanyxCollection() {
  throw new Error('qwanyxCollection() is deprecated. Use API functions directly.');
}

export async function persist(delta, qwantumId, di, ed, backup = false) {
  try {
    await apiPersist(delta, qwantumId, di, ed, backup);
  } catch (error) {
    console.error("Error persisting Qwantum:", error);
    throw error;
  }
}

export async function recallChildren(parentId) {
  try {
    console.log("Querying children with parentId:", parentId);
    const children = await apiRecallChildren(parentId);
    console.log("Children retrieved:", children);
    return children;
  } catch (error) {
    console.error("Error recalling children:", error);
    throw error;
  }
}

//the deleteQwanta Delete the qwanta and reassing the children to the parent...
export async function deleteQwanta(qwantumId) {
  try {
    const result = await apiDeleteQwanta(qwantumId);
    console.log(`Qwanta ${qwantumId} deleted successfully.`);
    return result;
  } catch (error) {
    console.error("Error deleting Qwanta:", error);
    throw error;
  }
}


export async function recursiveDelete(qwantumId) {
  try {
    const result = await apiRecursiveDelete(qwantumId);
    console.log(`Qwanta ${qwantumId} and its descendants deleted successfully.`);
    return result;
  } catch (error) {
    console.error("Error during optimized recursive deletion:", error);
    throw error;
  }
}




export async function sync(qwantumId) {
  try {
    const document = await apiSync(qwantumId);
    return document; // Return the full document to Qwanta.js for merging
  } catch (error) {
    //console.error("Error syncing Qwantum:", error);
    throw error;
  }
}


//DOCUMENTS NAVIGATION

export async function getBatch(parentDi, startId = null, limit = 50) {
  try {
    const batch = await apiGetBatch(parentDi, startId, limit);
    return batch; // Return the fetched batch
  } catch (error) {
    console.error("Error fetching batch of Qwantas:", error);
    throw error;
  }
}

export async function getPreviousBatch(parentDi, startId, limit = 50) {
  try {
    const batch = await apiGetPreviousBatch(parentDi, startId, limit);
    return batch; // Already reversed by the API
  } catch (error) {
    console.error("Error fetching previous batch of Qwantas:", error);
    throw error;
  }
}

export async function getTotalCount(parentDi) {
  try {
    const count = await apiGetTotalCount(parentDi);
    return count; // Return the total count of documents
  } catch (error) {
    console.error("Error fetching total count of Qwantas:", error);
    throw error;
  }
}
